import React, { useEffect, useState } from "react";
import { Alert, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import MovimientoFormulario from "./MovimientoFormulario";
import { crearMovimientoExtracto, getBancosExtracto } from "../services/egresosService";

const dos = (n) => String(n).padStart(2, "0");

// Fecha inicial: hoy si cae dentro del mes que se está viendo; si no, el día 1 de ese mes.
const fechaInicial = (mes, year) => {
  const h = new Date();
  return h.getMonth() + 1 === mes && h.getFullYear() === year ? `${year}-${dos(mes)}-${dos(h.getDate())}` : `${year}-${dos(mes)}-01`;
};

const vacio = (mes, year) => ({ tipo: "credito", fecha: fechaInicial(mes, year), monto: "", itf: "", banco: "BNB", cod_transaccion: "", referencia: "", descripcion: "", adicional: "" });

// Registrar a mano UN movimiento del extracto (cuando no está en el Excel del banco). Queda como Pendiente, igual que al importar,
// para enlazarlo después con sus cheques o pagos en la pestaña "No existen".
export default function RegistrarMovimientoDialog({ open, mes, year, onClose, onGuardado }) {
  const [form, setForm] = useState(vacio(mes, year));
  const [bancos, setBancos] = useState([]);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    setForm(vacio(mes, year));
    setError("");
    getBancosExtracto().then(({ data }) => setBancos(Array.isArray(data) ? data : [])).catch(() => setBancos([]));
  }, [open, mes, year]);

  const esDebito = form.tipo === "debito";

  const guardar = async (e) => {
    e.preventDefault();
    setGuardando(true);
    setError("");
    try {
      const { data } = await crearMovimientoExtracto({ ...form, itf: esDebito ? form.itf : "" });
      onGuardado(data);
    } catch (err) {
      setError(err?.response?.data?.error || "No se pudo registrar el movimiento.");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Dialog open={open} onClose={guardando ? undefined : onClose} maxWidth="sm" fullWidth component="form" onSubmit={guardar} scroll="paper">
      <DialogTitle sx={{ py: 1.25, borderBottom: 1, borderColor: "divider" }}>
        <Typography sx={{ fontSize: 17, fontWeight: 800 }}>Registrar movimiento del extracto</Typography>
        <Typography sx={{ fontSize: 12, color: "text.secondary" }}>Para un movimiento que no vino en el Excel del banco</Typography>
      </DialogTitle>
      <DialogContent sx={{ bgcolor: "background.default", p: 1.5, pt: "16px !important", display: "grid", gridAutoRows: "max-content", gap: 1.25, alignContent: "start" }}>
        {error && <Alert severity="error" onClose={() => setError("")}>{error}</Alert>}
        <Alert severity="info" sx={{ py: 0 }}>
          Queda como <b>Pendiente</b>; luego lo enlazas con sus cheques o pagos en la pestaña «No existen».
        </Alert>
        <MovimientoFormulario form={form} setForm={setForm} bancos={bancos} />
      </DialogContent>
      <DialogActions sx={{ px: 2, py: 1, borderTop: 1, borderColor: "divider" }}>
        <Button onClick={onClose} disabled={guardando} sx={{ textTransform: "none" }}>Cancelar</Button>
        <Button type="submit" variant="contained" disabled={guardando} sx={{ textTransform: "none", fontWeight: 700, minWidth: 170 }}>
          {guardando ? <CircularProgress size={20} color="inherit" /> : "Registrar movimiento"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
